<template>
  <v-card :key="`card_${match.id}`" :class="`elevation-${elevation}`">
    <v-card-text :class="{ 'cursor-pointer': !hiddeDetails }" @click="goMatch">
      <!--
      <div>config:{{ config }}</div> 
      <div>adminMode:{{ adminMode }}</div> 
      <div>editorMode:{{ editorMode }}</div> 
      <div>loggedMode:{{ loggedMode }}</div> 
      <div>sport:{{ sport }}</div> 
      -->
      <v-layout row wrap class="matchsContainer">
        <v-flex
          v-if="(adminMode || editorMode) && matchProcessed.displayStats"
          xs12
          class="text-xs-center"
        >
          <v-btn :class="reverse ? 'info' : ''" small @click.stop="toogleReverse">
            <v-icon>repeat</v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          v-if="matchProcessed && matchProcessed.sport && matchProcessed.sport.name"
          xs12
          class="text-xs-center grey--text py-0"
        >
          <span>{{ $t(`sport.types.${matchProcessed.sport.name}.name`) }}</span>
        </v-flex>
        <v-flex xs12 class="text-xs-center caption grey--text py-0 mb-2">
          <span v-if="matchProcessed.category">{{ matchProcessed.category }}</span>
          <span v-else>{{ $t('entity.match.category.label') }}</span>
          <span v-if="matchProcessed.day">
            - {{ $t('entity.match.day.label') }} {{ matchProcessed.day }}
          </span>
        </v-flex>
        <v-flex :style="{ color: style.primary }" xs12 class="team text-xs-center title">
          <v-layout :reverse="reverse" row wrap>
            <v-flex
              :class="{ winner: matchProcessed.winnerLocal, loser: matchProcessed.winnerVisitor }"
              xs6
            >
              <img
                v-if="matchProcessed.localTeamLogo"
                :src="matchProcessed.localTeamLogo"
                class="logo mb-2"
              />
              <br v-if="matchProcessed.localTeamLogo" />
              <span v-if="matchProcessed.localTeam">{{ matchProcessed.localTeam }}</span>
              <span v-else>{{ $t('entity.match.localTeam.label') }}</span>
            </v-flex>
            <v-flex
              :class="{ winner: matchProcessed.winnerVisitor, loser: matchProcessed.winnerLocal }"
              xs6
            >
              <img
                v-if="matchProcessed.visitorTeamLogo"
                :src="matchProcessed.visitorTeamLogo"
                class="logo mb-2"
              />
              <br v-if="matchProcessed.visitorTeamLogo" />
              <span v-if="matchProcessed.visitorTeam">{{ matchProcessed.visitorTeam }}</span>
              <span v-else>{{ $t('entity.match.visitorTeam.label') }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <MatchBoard
            :match="matchProcessed"
            :reverse="reverse"
            @goMatch="goMatch"
            @onAddPlayer="onAddPlayer"
            @onSendEvent="onSendEvent"
            @onRemoveLastEvent="onRemoveLastEvent"
          />
        </v-flex>
        <v-flex v-if="displayComments" xs12>
          <MatchComments
            :match="match"
            :sport="sport"
            :is-admin="adminMode || editorMode"
            @onAddComment="onAddComment"
            @onRemoveComment="onRemoveComment"
          />
        </v-flex>

        <v-flex v-if="!hideInfo" xs12>
          <div class="title mb-2">{{ $t('page.match.information') }}</div>
          <div>
            <v-icon>today</v-icon>
            {{ matchProcessed.date }}
          </div>
          <div v-if="matchProcessed.location">
            <v-icon>place</v-icon>
            {{ matchProcessed.location }}
            <a
              v-if="matchProcessed.mapLink"
              :href="matchProcessed.mapLink"
              target="_blank"
              class="mapLink"
            >
              <v-icon>map</v-icon>
            </a>
          </div>
        </v-flex>

        <v-flex v-if="showPoweredBy" xs12 class="my-2 mr-2 powered">
          <v-spacer />
          <span class="pr-1">Powered by</span>
          <a :href="$t('site.fullUrl')" target="_blanck">{{ $t('site.name') }}</a>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions v-if="!hideMatchMenu" light>
      <v-btn v-if="!hiddeDetails" icon flat color="grey" @click="goMatch">
        <!--<span>{{ $t('page.matches.details') }}</span>-->
        <v-icon>settings_overscan</v-icon>
      </v-btn>
      <v-spacer />
      <v-menu :key="`menuShare-${match.id}`" open-on-hover top offset-y>
        <v-btn slot="activator" icon flat color="grey">
          <!--<span>{{ $t(`page.matches.share`) }}</span>-->
          <v-icon>share</v-icon>
        </v-btn>
        <social-sharing v-bind="sharingConfig" inline-template>
          <v-list>
            <v-list-tile>
              <v-list-tile-title>
                <network network="twitter">
                  <v-icon>fab fa-twitter-square</v-icon>
                  Twitter
                </network>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-title>
                <network network="facebook">
                  <v-icon>fab fa-facebook</v-icon>
                  Facebook
                </network>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-title>
                <network network="whatsapp">
                  <v-icon>fab fa-whatsapp-square</v-icon>
                  Whatsapp
                </network>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-title>
                <network network="email">
                  <v-icon>fas fa-envelope</v-icon>
                  Mail
                </network>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </social-sharing>
      </v-menu>
      <template v-if="adminMode">
        <v-menu :key="`menu-${match.id}`" open-on-hover top offset-y>
          <v-btn slot="activator" icon flat color="warning">
            <!--<span>{{ $t(`page.matches.options`) }}</span>-->
            <v-icon>more_horiz</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="editItem(match.id)">
              <v-list-tile-title>
                <v-icon>edit</v-icon>
                {{ $t(`page.matches.edit.button`) }}
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="toogleBlockMatch">
              <v-list-tile-title v-if="!match.blocked">
                <v-icon>lock_outline</v-icon>
                {{ $t(`page.matches.blockMatch`) }}
              </v-list-tile-title>
              <v-list-tile-title v-else>
                <v-icon>lock_open</v-icon>
                {{ $t(`page.matches.unblockMatch`) }}
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile color="red" @click="deleteItem">
              <v-list-tile-title>
                <v-icon color="red">delete_forever</v-icon>
                {{ $t(`general.delete`) }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <BaseFormModal
          v-if="menuOpen"
          :item="match"
          :entity="entity"
          :model="model"
          :menu-open.sync="menuOpen"
          @onUpdate="onUpdate"
        />
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import BaseFormModal from '@/components/Base/BaseFormModal'
import MatchProcessHelper from '@/lib/MatchProcessHelper'
import matchModel from '@/lib/data/models/match'
import SportHelper from '@/lib/SportHelper'
import MatchBoard from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard'
import MatchComments from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchComments'
import SocialSharing from 'vue-social-sharing'
const debug = require('debug')('OD::MatchCard')

export default {
  name: 'MatchCard',
  components: {
    BaseFormModal,
    MatchBoard,
    MatchComments,
    SocialSharing,
  },
  props: {
    club: {
      type: Object,
      required: true,
    },
    match: {
      type: Object,
      required: true,
    },
    sport: {
      type: Object,
      required: true,
    },
    hiddeDetails: {
      type: Boolean,
      default: false,
    },
    adminMode: {
      type: Boolean,
      default: false,
    },
    editorMode: {
      type: Boolean,
      default: false,
    },
    viewerMode: {
      type: Boolean,
      default: false,
    },
    loggedMode: {
      type: Boolean,
      default: false,
    },
    displayCharts: {
      type: Boolean,
      default: false,
    },
    displayComments: {
      type: Boolean,
      default: false,
    },
    displayStats: {
      type: Boolean,
      default: false,
    },
    displaySets: {
      type: Boolean,
      default: false,
    },
    hideMenu: {
      type: Boolean,
      default: false,
    },
    hideInfo: {
      type: Boolean,
      default: false,
    },
    hideMatchMenu: {
      type: Boolean,
      default: false,
    },
    showPoweredBy: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      entity: 'match',
      menuOpen: false,
      reverse: false,
    }
  },
  computed: {
    ...mapState({
      style: state => state.style.style,
    }),
    model() {
      return matchModel
    },
    sharingConfig() {
      let setsText = ''
      this.match.sets.forEach((set, i) => {
        if (set.l !== 0 && set.v !== 0) {
          setsText += `- ${this.matchProcessed.setText} ${i + 1}: ${set.l}-${set.v}\r\n`
        }
      })

      const title = `${this.matchProcessed.category}: ${this.matchProcessed.localTeam} vs ${this.matchProcessed.visitorTeam}`
      let description =
        `${this.matchProcessed.category}` +
        `\r\n${this.matchProcessed.localTeam} vs ${this.matchProcessed.visitorTeam}` +
        `\r\nResultado: ${this.matchProcessed.result.l}-${this.matchProcessed.result.v}`
      if (setsText !== '') {
        description += `\r\n${this.matchProcessed.setTextPlural}:\r\n${setsText}`
      }
      const quote = description
      const href = this.$router.resolve({
        name: 'Match',
        params: {
          clubId: this.match.clubId,
          year: this.match.year,
          week: this.match.week,
          matchId: this.match.id,
        },
      }).href
      const host = `https://${this.$t('site.url')}`

      const url = host + href

      const hashtags = 'siguetuclub'
      const twitterUser = 'siguetuclub'
      const sharingConfig = {
        url,
        title,
        description,
        quote,
        hashtags,
        twitterUser,
      }
      // debug('sharingConfig', sharingConfig)
      return sharingConfig
    },
    matchProcessed() {
      debug('BBB', this.hideMenu)
      let matchProcessed = this.match.cache
      debug('CACHE', this.match.cache)
      if (!matchProcessed || matchProcessed === {}) {
        debug('ENTRO')
        let sport = _.cloneDeep(this.sport)
        if (this.sport.name !== this.match.sport) {
          debug('onAddMatch', 'entro')
          sport = SportHelper.getSportConfiguration(this.match.sport)
        }
        matchProcessed = MatchProcessHelper.process({
          club: this.club,
          sport: sport,
          match: this.match,
        })
      }
      const visualSetup = {
        adminMode: this.adminMode || this.editorMode,
        viewerMode: this.viewerMode,
        displayCharts: this.displayCharts,
        displayComments: this.displayComments,
        displayStats: this.displayStats,
        displaySets: this.displaySets,
        hideMenu: this.hideMenu,
        hideInfo: this.hideInfo,
      }
      matchProcessed = {
        ...matchProcessed,
        ...visualSetup,
      }
      return matchProcessed
    },
  },
  watch: {},
  created() {},
  methods: {
    toogleReverse() {
      debug('toogleReverse')
      this.reverse = !this.reverse
    },
    onAddPlayer(data) {
      this.$emit('onAddPlayer', data)
    },
    onSendEvent(data) {
      this.$emit('onSendEvent', data)
    },
    onRemoveLastEvent(data) {
      this.$emit('onRemoveLastEvent', data)
    },
    toogleBlockMatch() {
      this.$emit('onToogleBlockMatch', {
        matchId: this.match.id,
      })
    },
    goMatch() {
      this.$emit('onGo', this.match)
    },
    editItem(id) {
      this.menuOpen = true
    },
    async deleteItem(id) {
      const page = 'matches'
      const result = await this.$swal({
        title: this.$t(`page.${page}.delete.title`),
        text: this.$t(`page.${page}.delete.text`),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t(`page.${page}.delete.cancelButtonText`),
        confirmButtonText: this.$t(`page.${page}.delete.confirmButtonText`),
      })
      // debug('result', result)
      if (result) {
        this.$emit('onDeleteMatch', this.match)
        this.$swal({
          title: this.$t(`page.${page}.delete.confirm.title`),
          text: this.$t(`page.${page}.delete.confirm.text`),
          type: 'success',
          showConfirmButton: false,
          timer: 1500,
        })
      }
    },
    onUpdate(newItem, item) {
      debug('onUpdate', newItem, item)
      this.$emit('onUpdate', newItem, item)
    },
    onAddComment(data) {
      this.$emit('onAddComment', data)
    },
    onRemoveComment(data) {
      this.$emit('onRemoveComment', data)
    },
  },
}
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
.matchsContainer {
  align-items: center;
}
.logo {
  max-height: 30px;
  max-width: 30px;
}
.mapLink {
  text-decoration: none;
}
.set {
  .btn {
    margin: 4px 2px;
  }
}
.bottom-nav .btn:not(.btn--active) {
  -webkit-filter: none;
  filter: none;
  opacity: 1;
}
.result {
  .winner {
    color: green;
  }
  /*
  .loser {
  }
  */
}
.team {
  /*
  .winner {
  }
  */
  .loser {
    font-weight: lighter;
  }
}
.blink_me {
  animation: blinker 5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.2;
  }
}
</style>
